import React from 'react';
import ACImage from '~/components/ACImage';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';

let imgBanner;
if (Config.isPhotoAC()) {
  imgBanner = 'banner-creator-photo-ac.jpg';
} else if (Config.isIllustAC()) {
  imgBanner = 'banner-creator-illust-ac.jpg';
}

const Banner = () => {
  return (
    <div className="banner-container">
      <a href="/tw/sell-your-content" target="_blank">
        <ACImage
          className="image-banner"
          alt="banner image"
          src={`${Config.staticPrefix}/static/assets/image/banner/${imgBanner}`}
          objectFit="contain"
        />
      </a>
      <style jsx>
        {`
          .banner-container {
            width: 100%;
            height: 90px;
            // z-index: 999;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position: center;
            display: flex;
            justify-content: center;
            align-items: center;
            background: ${themeVariables.colors.primary};
            position: relative;
          }
          .image-banner {
            width: 729px;
            max-height: 90%;
          }
          @media (max-width: 500px) {
            .banner-container {
              padding-top: 0px;
            }
            .image-banner {
              max-width: 100%;
              max-height: 90%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Banner;
